export const ASSIGNMENT_TEMPLATES_LOAD_START = 'ASSIGNMENT_TEMPLATES_LOAD_START';
export const ASSIGNMENT_TEMPLATES_LOAD_SUCCESS = 'ASSIGNMENT_TEMPLATES_LOAD_SUCCESS';
export const ASSIGNMENT_TEMPLATES_CREATE_SUCCESS = 'ASSIGNMENT_TEMPLATES_CREATE_SUCCESS';
export const ASSIGNMENT_TEMPLATES_DELETE_SUCCESS = 'ASSIGNMENT_TEMPLATES_DELETE_SUCCESS';
export const ASSIGNMENT_TEMPLATES_LOAD_ERROR = 'ASSIGNMENT_TEMPLATES_LOAD_ERROR';
